import { render, staticRenderFns } from "./GigSubmissionsReviewTableRow.vue?vue&type=template&id=c043355c&scoped=true&"
import script from "./GigSubmissionsReviewTableRow.vue?vue&type=script&lang=js&"
export * from "./GigSubmissionsReviewTableRow.vue?vue&type=script&lang=js&"
import style0 from "./GigSubmissionsReviewTableRow.vue?vue&type=style&index=0&id=c043355c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c043355c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
